<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapSalesOrders"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="订单编号">
              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入订单编号" clearable/>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select
                  v-model="filter.salesOrderCategory"
                  clearable
                  placeholder="请选择订单类型">
                <el-option v-for="item in property" :key="item.no" :value="item.no" :label="item.name"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :loading="submitLoading"
            :disabled="scope.row.status !== 10"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
        <el-button
            v-if="limits.creatDeliveryAuth"
            type="primary"
            :disabled="scope.row.status === 10"
            @click="$refs.sapDeliveryEdt.open(scope.row)">
          交货单
        </el-button>
      </template>
    </view-table>
    <sales-order-edit ref="salesOrderEdit" :options="options" @save-success="loadData"/>
    <sap-delivery-edit ref="sapDeliveryEdt"/>
  </div>
</template>

<script>
  import SalesOrderEdit from "@/views/SalesManage/SalesOrder/SalesOrderEdit";
  import ViewTable from "@/components/ViewTable";
  import SapDeliveryEdit from "@/views/SalesManage/DeliveryBll/SapDeliveryEdit";

  export default {
    name: "SalesOrderList",
    components: {SapDeliveryEdit, SalesOrderEdit,ViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(4),
          editAuth: this.$auth(7),
          delAuth: this.$auth(9),
          subAuth: this.$auth(8),
          creatDeliveryAuth: this.$auth(135),
        },
        filter: {
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "salesOrderNO",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.salesOrderEdit.open(params.row, 0, true);
                    },
                  },
                },
                params.row.salesOrderNO,
              );
            },
          },
          {
            key: "action",
            width: 250,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.salesOrderEdit.open(row);
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.demandStatus !== "Y") {
          return  false;
        } else {
          return  true;
        }
      },
    },
  };
</script>
